import { Dispatch } from 'redux'
import {
  apiRequest,
  apiFailure,
  getRestaurantInfo as getRestaurantInfoReducer,
  getAnnouncement as getAnnouncementReducer,
  visit as visitReducer,
} from 'reducers/restaurantInfo.reducer'
import { restaurantInfoService } from 'services/restaurantInfo.service'
import IRestaurantInfo from 'models/IRestaurantInfo'
import IAnnouncement from 'models/IAnnouncement'
import IVisit from 'models/IVisit'

export const getRestaurantInfo =
  (slug: string) => async (dispatch: Dispatch) => {
    try {
      dispatch(apiRequest())

      const response = await restaurantInfoService.getRestaurantInfo(slug)
      if (response) {
        dispatch(
          getRestaurantInfoReducer({
            restaurantInfo: response.data as IRestaurantInfo,
          })
        )
      }
    } catch (error) {
      dispatch(apiFailure())
    }
  }

export const getAnnouncement =
  (slug: string) => async (dispatch: Dispatch) => {
    try {
      dispatch(apiRequest())

      const response = await restaurantInfoService.getAnnouncement(slug)
      if (response) {
        dispatch(
          getAnnouncementReducer({
            announcement: response.data as IAnnouncement,
          })
        )
      }
    } catch (error) {
      dispatch(apiFailure())
    }
  }

export const visit = (visitBody: IVisit) => async (dispatch: Dispatch) => {
  try {
    dispatch(apiRequest())

    const response = await restaurantInfoService.visit(visitBody)
    if (response) {
      dispatch(visitReducer(response))
    }
  } catch (error) {
    dispatch(apiFailure())
  }
}
